import useWindowSize from "./useWindowSize";
import defaultTheme from "../components/Theme/default-theme";
import { Devices } from "../consts/devices";
import { useMemo } from "react";

const useCurrentDevice = () => {
  const size = useWindowSize();

  const currentDevice = useMemo(() => {
    if (size.width === null) {
      return Devices.UNKNOWN;
    } else if (size.width < defaultTheme.size.tablet) {
      return Devices.MOBILE;
    } else if (size.width < defaultTheme.size.laptop) {
      return Devices.TABLET;
    } else if (size.width < defaultTheme.size.desktop) {
      return Devices.LAPTOP;
    } else {
      return Devices.DESKTOP;
    }
  }, [size.width]);
  return currentDevice;
};

export default useCurrentDevice;
